import { render } from "./AppLabel.vue?vue&type=template&id=1b668458&scoped=true&ts=true"
import script from "./AppLabel.vue?vue&type=script&lang=ts"
export * from "./AppLabel.vue?vue&type=script&lang=ts"

import "./AppLabel.vue?vue&type=style&index=0&id=1b668458&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b668458"]])

export default __exports__